import { FC } from "preact/compat";
import { useSignal } from "@preact/signals";
import { useApp } from "~/core";
import { Button, Dialog } from "~/components";
import { ConfirmationDialogProps } from "./interfaces";
import Loader from "~/assets/loader.svg";

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({ locale }) => {
    const {
        help: {
            admin: { unsaved, saveAll, closeEditor },
        },
    } = useApp();
    const confirmation = useSignal(false);
    const allSaving = useSignal(false);

    return (
        <Dialog show={confirmation} zIndex={51}>
            <div className="flex max-w-[560px] flex-col rounded-xl border border-gray-300 bg-white p-4 shadow-lg">
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-bold">You have unsaved data</h2>
                    {allSaving.value && (
                        <Loader
                            width="24"
                            height="24"
                            className="text-sky-500"
                        />
                    )}
                </div>
                <p className="mt-2">
                    <span className="text-gray-500">
                        The following tags have been changed but haven't been
                        saved:{" "}
                    </span>
                    {unsaved.value.map((i) => i.tag).join(", ")}.
                </p>
                <div className="mt-6 flex justify-between gap-x-4">
                    <Button
                        variant="secondary"
                        className="!hidden"
                        onClick={async () => {
                            allSaving.value = true;

                            try {
                                await saveAll(locale.peek());

                                confirmation.value = false;
                                closeEditor();
                            } catch (err: unknown) {
                                console.error(err);
                            }

                            allSaving.value = false;
                        }}
                    >
                        Save all changes
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => {
                            confirmation.value = false;
                            closeEditor(true);
                        }}
                    >
                        Discard all changes
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => (confirmation.value = false)}
                    >
                        Continue editing
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default ConfirmationDialog;
